import React, { useState } from "react";
import _ from "lodash";
import {
  Button,
  Card,
  Col,
  ProgressBar,
  Row,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import SplitNumber from "../../../components/SplitNumber";
import CountdownTimer from "./Counter";
import ReserveModal from "./ReserveModal";
import moment from "moment-jalaali";

function PackageCard({ data, services }) {
  const today = moment().format("jYYYY/jMM/jDD");
  let opacityClass = "";
  const [showReserveModal, setShowReserveModal] = useState(false);
  const handleShowModal = (value) => {
    setShowReserveModal(value);
  };

  let formattedData = { ...data };
  try {
    const packageItems = _.isArray(
      JSON.parse(data.amusementServicePackageItemsJson)
    )
      ? JSON.parse(data.amusementServicePackageItemsJson).map((item) => ({
          ...item,
          id: item.amusementServiceId,
        }))
      : [];
    const intersection = _.intersectionBy(services, packageItems, "id");
    let packageCurrentPriceSum = 0;
    let packageOriginalPriceSum = 0;
    const finalArray = packageItems.map((item) => {
      const found = intersection.find((i) => i.id === item.amusementServiceId);
      packageCurrentPriceSum += item.price;
      const foundReserveItem = found.amusementServiceReserveItems.find(
        (i) => i.id === item.amusementServiceReserveItemId
      );
      if (foundReserveItem)
        packageOriginalPriceSum += parseInt(foundReserveItem.price);
      return {
        ...item,
        amusementServiceTitle: found ? found.name : "",
        originalPrice: foundReserveItem && foundReserveItem.price,
        imageUrl: found.imageUrl,
        title: foundReserveItem.title,
      };
    });
    formattedData.price = packageCurrentPriceSum;
    formattedData.originalPrice = packageOriginalPriceSum;
    formattedData.packageItemsArray = finalArray;
  } catch (error) {
    console.log("error =>", error);
  }

  if (
    today >
    moment(formattedData.endDate, "jYYYY/jMM/jDD").format("jYYYY/jMM/jDD")
  ) {
    opacityClass = "opacity-50";
  }
  return (
    <>
      {showReserveModal && (
        <ReserveModal
          showReserveModal={showReserveModal}
          setShowReserveModal={setShowReserveModal}
          data={formattedData}
        />
      )}
      <Card className={`rounded-4 h-100 ${opacityClass}`}>
        <Card.Header className="bg-white border-bottom-0 text-center fw-bold rounded-4 px-2">
          <h2 className="border-bottom fs-101 pt-2 pb-3">
            {formattedData.title}
          </h2>
        </Card.Header>
        <Card.Body className="pt-0 px-2 pb-2">
          <div className="fs-08 text-center">
            با خرید این پکیج، تفریحات زیر را{" "}
            <span className="text-danger fw-bold">
              <SplitNumber
                number={formattedData.originalPrice - formattedData.price}
              />{" "}
              تومان ارزانتر
            </span>{" "}
            رزرو کنید.
          </div>
          <div className="d-flex aling-items-center justify-content-center rounded-image pt-3">
            {formattedData.packageItemsArray &&
              formattedData.packageItemsArray.map((packageItemData, index) => (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id={"tooltip" + packageItemData.id}>
                      {packageItemData.amusementServiceTitle}
                    </Tooltip>
                  }
                >
                  <span
                    className="ms-1"
                    data-tip
                    data-for={"tooltip" + packageItemData.id}
                  >
                    <img
                      key={index}
                      src={`https://localhost:9003${packageItemData.imageUrl}`}
                      alt={packageItemData.amusementServiceTitle}
                      className="rounded-circle"
                    />
                  </span>
                </OverlayTrigger>
              ))}
          </div>

          <div className="after-plus d-flex flex-wrap align-items-center justify-content-center fs-08 pt-2">
            <span className="opacity-75 pe-1">تفریحات پکیج: </span>
            {formattedData.packageItemsArray &&
              formattedData.packageItemsArray.map((packageItemData, index) => (
                <div>{packageItemData.amusementServiceTitle}</div>
              ))}
          </div>
        </Card.Body>
        <Card.Footer className="bg-white rounded-4 rounded-top-0 border-top-0">
          <Row className="border-top pt-3 pb-0">
            <Col className="text-center">
              <div className="">
                <span className="text-decoration-line-throught-rotate border-secondary text-black-06 fs-08">
                  <>
                    <SplitNumber number={formattedData.originalPrice} />
                    <span className="ps-1">تومان</span>
                  </>
                </span>
              </div>
              <div className="fs-101 fw-bold">
                <>
                  <SplitNumber number={formattedData.price} />
                  <span className="ps-1">تومان</span>
                </>
              </div>
            </Col>
            <Col xs="auto" className="ps-0 pe-2 text-end my-auto">
              {today >
              moment(formattedData.endDate, "jYYYY/jMM/jDD").format(
                "jYYYY/jMM/jDD"
              ) ? (
                <Button variant="" disabled className="px-4">
                  غیرقابل رزرو
                </Button>
              ) : (
                <Button
                  variant="success"
                  className=" fs-09 rounded-2"
                  onClick={handleShowModal}
                >
                  افزودن به سبد خرید
                </Button>
              )}
            </Col>
            <Col xs="12" className="py-3">
              {/* <ProgressBar
                variant="danger"
                now={Math.ceil((data.soldOut * 100) / data.capacity)}
              /> */}
            </Col>
            <Col xs="auto" className="fs-075 pb-2">
              {/* {Math.ceil((data.soldOut * 100) / data.capacity)} % فروش رفته */}
            </Col>
            <Col xs className="pb-2">
              {today >
              moment(formattedData.endDate, "jYYYY/jMM/jDD").format(
                "jYYYY/jMM/jDD"
              ) ? (
                <div className="text-end text-danger">منقضی شده</div>
              ) : (
                <CountdownTimer
                  targetDate={
                    formattedData.endDate
                      ? formattedData.endDate
                          .replace("T", " ")
                          .replaceAll("-", "/")
                      : ""
                  }
                />
              )}
            </Col>
          </Row>
        </Card.Footer>
      </Card>
    </>
  );
}
export default PackageCard;
